"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardModule = void 0;
const tslib_1 = require("tslib");
const AdaptableModuleBase_1 = require("./AdaptableModuleBase");
const ModuleConstants = tslib_1.__importStar(require("../Utilities/Constants/ModuleConstants"));
const DashboardRedux = tslib_1.__importStar(require("../Redux/ActionsReducers/DashboardRedux"));
class DashboardModule extends AdaptableModuleBase_1.AdaptableModuleBase {
    constructor(api) {
        super(ModuleConstants.DashboardModuleId, ModuleConstants.DashboardFriendlyName, 'dashboard', 'DashboardPopup', 'The Dashboard - usually placed above the Grid - is designed to provide quick access to commonly required AdapTable functionalty', api);
    }
    updateOldConfig() {
        let dashboardState = this.api.dashboardApi.getDashboardState();
        if (dashboardState.VisibleButtons) {
            this.api.logWarn(`Updating Obsolete VisibleButtons Config for DashboardState: [${dashboardState.VisibleButtons}]`);
            this.api.dashboardApi.setModuleButtons(dashboardState.VisibleButtons);
        }
    }
    handleAdaptableReady() {
        // we used to create a default tab here but we no longer do // this.api.internalApi.setDefaultDashboardTab();
        // this handler reacts to the 'AdaptableReady' event,
        // but so do all the other possible handlers of the 'DashboardChanged' event
        // therefore, we give them a head start to subscribe to 'DashboardChanged' before emitting it
        setTimeout(() => {
            if (this.api.isDestroyed()) {
                return;
            }
            this.api.dashboardApi.internalApi.fireDashboardChangedEvent('ADAPTABLE_READY', null, this.api.dashboardApi.getDashboardState());
        }, 20);
    }
    addColumnMenuItems() {
        return this.buildMenuItems();
    }
    addContextMenuItems(menuContext) {
        return this.buildMenuItems();
    }
    buildMenuItems() {
        if (this.isModuleAvailable()) {
            let menuItems = [];
            if (this.isModuleEditable()) {
                menuItems.push(this.createColumnMenuItemClickFunction('Configure', 'settings', () => this.api.dashboardApi.openDashboardSettingsPanel()));
            }
            if (this.api.dashboardApi.getDashboardState().IsCollapsed) {
                menuItems.push(this.createColumnMenuItemReduxAction('Expand', 'expand', DashboardRedux.DashboardSetIsCollapsed(false)));
            }
            else {
                menuItems.push(this.createColumnMenuItemReduxAction('Collapse', 'collapse', DashboardRedux.DashboardSetIsCollapsed(true)));
            }
            if (this.api.dashboardApi.getDashboardState().IsFloating) {
                menuItems.push(this.createColumnMenuItemReduxAction('Dock', 'dock', DashboardRedux.DashboardSetIsFloating(false)));
            }
            else if (this.api.optionsApi.getDashboardOptions().canFloat) {
                menuItems.push(this.createColumnMenuItemReduxAction('Float', 'dock', DashboardRedux.DashboardSetIsFloating(true)));
            }
            if (this.api.dashboardApi.getDashboardState().IsHidden) {
                menuItems.push(this.createColumnMenuItemReduxAction('Show', 'visibility-on-bold', DashboardRedux.DashboardSetIsHidden(false)));
            }
            else {
                menuItems.push(this.createColumnMenuItemReduxAction('Hide', 'visibility-off-bold', DashboardRedux.DashboardSetIsHidden(true)));
            }
            return [
                {
                    label: this.moduleInfo.FriendlyName,
                    isVisible: true,
                    module: this.moduleInfo.ModuleName,
                    icon: {
                        name: 'dashboard',
                    },
                    subItems: menuItems,
                },
            ];
        }
    }
}
exports.DashboardModule = DashboardModule;
